/**************************************************************************************************/
/*   File: /src/app/shared/models/authorization.status.ts                                         */
/*   Project: newplan-frontend                                                                    */
/*   Created Date: Thursday February 14th 2019                                                    */
/*   Author: Andrea Zamboni andrea.zamboni@trilogis.it                                            */
/*   -----                                                                                        */
/*   Last Modified: Fri Feb 22 2019                                                               */
/*   Modified By: Andrea Zamboni                                                                  */
/*   -----                                                                                        */
/*   Copyright (c) 2019 Trilogis s.r.l. for SIAG                                                  */
/**************************************************************************************************/
/**
 * The authorization status
 */
export class AuthorizationStatus {
    /**
     * The status
     */
    status: number;
    /**
     * The description
     */
    description: string;
}